export default __webpack_public_path__ + "static/2-22ca81c52264abcf463852e8614ab9d1.png";